import { render, staticRenderFns } from "./BlockRedeem.vue?vue&type=template&id=36e5941b&"
import script from "./BlockRedeem.vue?vue&type=script&lang=js&"
export * from "./BlockRedeem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports